import React from 'react'
import { CustomerStatus as CustomerStatusItems } from '@ztechapps/customer.common'
import { Status } from '@ztechapps/webui.util'

export const CustomerStatus = ({ value }) => {
  let type: string
  if (value?.toLowerCase?.() === CustomerStatusItems.inActive.value.toLowerCase()) {
    type = 'muted'
  } else {
    type = 'info'
  }

  return <Status value={value} type={type} />
}
